module.exports = __webpack_public_path__ + "img/court.c23ce5bb.png";